import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Fichier} from './fichier.model';
import {JhiArchiveService} from './archive.service';
import {AlertService} from 'ng-jhipster';
import {ExportService} from '../../shared';
import {ConfirmationService} from 'primeng/components/common/api';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'tree-view',
    templateUrl: 'tree-view.html'
})

export class TreeView implements OnInit {
    @Input() listeRepertoire: Array<Fichier>;
    @Output() refreshTreeView: EventEmitter<Boolean> = new EventEmitter<Boolean>();

    constructor(private archiveService: JhiArchiveService,
                private alertService: AlertService,
                private confirmationService: ConfirmationService,
                private translateService: TranslateService
    ) {
    }

    ngOnInit() {
        if(this.listeRepertoire) {
            this.listeRepertoire = this.listeRepertoire.sort((f1,f2) => f1.nom < f2.nom ? 1 : (f1.nom > f2.nom ? -1 : 0));
        }
    }

    download(file: Fichier) {
        this.archiveService.getFile(file).subscribe(
            (archive) => {
                ExportService.download(archive, file.nom);
            },
            (response) => {
                this.onError(response);
            });


    }

    onError(event) {
        if (event.xhr) {
            this.alertService.error(event.xhr.response, null, null);
        } else if (event.headers && event.headers._headers && event.headers._headers.get('x-cadensapp-error') != null
            && event.headers._headers.get('x-cadensapp-entity') != null) {
            this.alertService.error(event.headers._headers.get('x-cadensapp-error')[0],
                {'entityName': event.headers._headers.get('x-cadensapp-entity')[0]}, null);
        } else if (event.headers && event.headers._headers && event.headers._headers.get('x-cadensapp-error') != null ) {
            this.alertService.error(event.headers._headers.get('x-cadensapp-error')[0], null, null);
        } else if (event.message) {
            this.alertService.error(event.message, null, null);
        } else {
            this.alertService.error('error.internalServerError', null, null);
        }
    }


    deleteRepertoire(repertoire: Fichier) {
        this.confirmationDelete(repertoire) ;
    }

    confirmationDelete(repertoire: Fichier)  {
        this.confirmationService.confirm({
            message: this.translateService.instant('archive.confirmDelete.question'),
            header: this.translateService.instant('archive.confirmDelete.title'),
            icon: 'fa fa-trash',
            accept: () => {
                this.archiveService.deleteRepertoire(repertoire).subscribe(
                    (archive) => {
                        this.refreshTreeView.emit(true);
                    },
                    (response) => {
                        this.refreshTreeView.emit(true);
                        this.onError(response);
                    });
            }
        });
    }

    // the treeview component is recursively called
    onRefreshTreeView(refresh: boolean) {
        this.refreshTreeView.emit(refresh);
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/archive/tree-view.ts